import { render } from "./GeneralSalary.vue?vue&type=template&id=c43c6b6e"
import script from "./GeneralSalary.vue?vue&type=script&lang=js"
export * from "./GeneralSalary.vue?vue&type=script&lang=js"

import "./GeneralSalary.vue?vue&type=style&index=0&id=c43c6b6e&lang=less"

import exportComponent from "D:\\VueProject\\everlife-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__